import { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Button,
  Card,
  Chip,
  IconButton,
  Modal,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import DeleteIcon from "@mui/icons-material/Delete";
import { errorToast, successToast } from "../../helpers";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import WarnModal from "../../components/WarnModal";
import { useDeleteNotificationMutation } from "../../services/notification";
import {
  useRefundPaymentMutation,
  useRefundRequestsMutation,
} from "../../services/order";
import { generateResponsiveStyle } from "../../utils/modalStyle";
import CloseIcon from "@mui/icons-material/Close";
import Pagination from "../../components/Pagination";
import { getFromStorage } from "../../constants/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import useTranslation from "../../hooks/Translation";

const ManageRefunds = () => {
  const style = generateResponsiveStyle();
  const t = useTranslation();
  const currency = getFromStorage(STORAGE_KEYS.currency);
  const [makeRefund] = useRefundPaymentMutation();
  const [refundReq] = useRefundRequestsMutation();
  const [row1, setRow1] = useState<any>();
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState<any>(1);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [totalRecords, setTotalRecords] = useState<any>(0);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(0);
  const [selectedRefundId, setSelectedRefundId] = useState("");

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const formatDate = (isoString: string | number | Date) => {
    const date = new Date(isoString);
    return date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getAllRefundRequests = async (page: number) => {
    let body = {
      length: limit,
      start: page,
      search: debouncedSearchTerm,
      type: value === 0 ? 2 : 1,
    };

    try {
      const response = await refundReq(body).unwrap();
      if (response?.status === 200) {
        setRow1(response?.data);
        setTotalRecords(response?.total_records);
        setTotalPages(
          response?.total_records
            ? Math.ceil(response?.total_records / limit)
            : 1
        );
      } else {
        setRow1([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  const handleRefund = async (id: number) => {
    let body = {
      refund_amount: amount,
      type: value === 0 ? 2 : 1,
      refund_id: selectedRefundId,
    };

    try {
      const response = await makeRefund({ body, id }).unwrap();
      if (response?.status === 200) {
        getAllRefundRequests(page);
        setModalOpen(false);
        setAmount("");
        successToast(t.main.refundedSuccess);
      } else {
        setAmount("");
        setModalOpen(false);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setAmount("");
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
  };

  useEffect(() => {
    getAllRefundRequests(page);
  }, [page, debouncedSearchTerm, limit, value]);

  return (
    <div>
      <div className="main_layout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.manageRefunds}</h1>
        </div>
        {/* <Loader isLoasd={isLoading} /> */}
        <Card className="cards">
          <Box className="cards_header" style={{ marginBottom: 20 }}>
            <Box className="cards_header_left">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </Box>

          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label={t.main.exchangeRefunds} {...a11yProps(0)} />
              <Tab label={t.main.returnRefunds} {...a11yProps(1)} />
            </Tabs>
          </Box>

          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>{t.main.orderId}</TableCell>
                  <TableCell>{t.main.name}</TableCell>
                  <TableCell>{t.main.email}</TableCell>
                  <TableCell>{t.main.phoneNumber}</TableCell>
                  <TableCell>{t.main.date}</TableCell>
                  <TableCell>{t.main.refundAmount}</TableCell>
                  <TableCell>{t.main.amountSetByVendor}</TableCell>
                  <TableCell align="center">{t.main.refund}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {row1?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      {t.error.noData}
                    </TableCell>
                  </TableRow>
                ) : (
                  row1?.map((row: any, index: any) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {(page - 1) * 10 + index + 1}
                      </TableCell>
                      <TableCell>#{row?.order_track_id}</TableCell>
                      <TableCell> {row?.user || "-"}</TableCell>
                      <TableCell> {row?.email || "-"}</TableCell>
                      <TableCell>
                        {" "}
                        {`${row?.country_code || ""} ${row?.phone_no || "-"}`}
                      </TableCell>
                      <TableCell> {formatDate(row?.created_at)}</TableCell>
                      <TableCell>
                        {currency === "USD" ? "USD" : "AED"}{" "}
                        {value === 0 ? row?.refund_pay : row?.amount_pay}
                      </TableCell>

                      <TableCell>
                        {currency === "USD" ? "USD" : "AED"}{" "}
                        {row?.amount_set_by_vendor || "0"}
                      </TableCell>

                      <TableCell>
                        {row?.is_refunded_successfully ? (
                          <Chip
                            label={t.main.refunded}
                            variant="outlined"
                            onClick={() => {}}
                            sx={{ borderColor: "black" }}
                          />
                        ) : (
                          <Chip
                            label={t.main.refund}
                            variant="outlined"
                            onClick={() => {
                              setSelectedRefundId(row?.id);
                              setSelectedId(row?.order_id_for_payment);
                              setModalOpen(true);
                            }}
                            sx={{ borderColor: "#2B604C" }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </div>
      {row1?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={row1}
          page={page}
          onPageChange={setPage}
          totalPages={totalPages}
          setTotalPages={setTotalPages}
          limit={limit}
          setLimit={setLimit}
          totalRecords={totalRecords}
        />
      ) : (
        ""
      )}
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="modal_title">
            <Typography id="modal-modal-title" component="h2">
              {t.main.refundPayment}
            </Typography>
            <CloseIcon
              className="cross_icn_logout"
              onClick={() => setModalOpen(false)}
            />
          </div>

          <div className="modal_body">
            <div className="control_group">
              <TextField
                className="text_field"
                hiddenLabel
                placeholder={t.main.pricePerUnit}
                fullWidth
                inputProps={{ maxLength: 10 }}
                type="text"
                variant="outlined"
                value={amount}
                onChange={(val) => {
                  const value = val.target.value;
                  if (value === " " || value === ".") return;

                  // Regex to allow only numbers with up to two decimal places
                  if (/^\d*\.?\d{0,2}$/.test(value)) {
                    setAmount(value);
                  }
                }}
              />
            </div>

            <div className="form_btn">
              <Button
                disabled={!amount}
                className="btn btn_primary"
                onClick={() => {
                  handleRefund(selectedId);
                }}
              >
                {t.main.update}
              </Button>
              <Button
                className="btn btn_secondary"
                onClick={() => setModalOpen(false)}
              >
                {t.main.cancel}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default ManageRefunds;
